/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
  "jquery",
  "underscore",
  "service/channel",
  "utils/url"
], function(
  $,
  _,
  Channel,
  URL
) {

  var GENERIC_FALLBACK_TIMEOUT = 90000;
  
  var AjaxChannel = Channel.extend({
    xhrFields: { withCredentials: true },
    internalCall: function(path, request, responseObserver, formatOptions, headers, options) {
      var that = this,
          promise = that.createDeferredCallFinishedPromise(that);
      
      // crossDomain ajax attribute is available from jQuery 1.5
      $.support.cors = true;

      var dataType = formatOptions && formatOptions.dataType || 'json';
      var data = {};
      if (request && !_.isEmpty(request)) {
        data = /json/i.test(dataType) ? JSON.stringify(request) : request;
      };

      if(options && options.xhrFields) {
        this.setXhrFields(options.xhrFields);
      }

      $.ajax({
        url: this.get("url") + (path || ""),
        type: options && options.method || "post",
        crossDomain: options && options.crossDomain || true,
        xhrFields: this.xhrFields,
        headers: options && options.headers || {},
        dataType: dataType,
        data: data,
        context: this,
        timeout: this.getAjaxTimeout(options, path)
      }).done(function(data) { // success
        that.success(data, promise, responseObserver);
      }).fail(function(jqXHR, textStatus, errorThrown) { // failure
        var err = {status: jqXHR.status, message: textStatus, url: this.get("url"), error: errorThrown};
        that.error(err, promise, responseObserver);
      });
      
      return promise;
    },
    
    /**
     * An object of fieldName-fieldValue pairs to set on the native XHR object. eg. withCredentials, onprogress etc.
     * @param {*} fields 
     */
    setXhrFields: function(fields) {
      var xhrFields = {};
      _.extend(xhrFields, this.xhrFields, fields);
      this.xhrFields = xhrFields;
    },

    getAjaxTimeout: function(callOptions, path) {
      // Path might come with query params
      path = URL.removeQueryParams(path);

      // Fallback to default generic timeout
      var fallbackTimeoutInApplication = GENERIC_FALLBACK_TIMEOUT;

      if (
        this.options &&
        this.options.ajaxOptions &&
        this.options.ajaxOptions.requestTimeoutInMs
      ) {
        fallbackTimeoutInApplication = 
          this.options.ajaxOptions.requestTimeoutInMs.genericFallbackTimeout ||
          fallbackTimeoutInApplication;

        if ( this.options.ajaxOptions.requestTimeoutInMs[path] !== undefined ) {

           return this.options.ajaxOptions.requestTimeoutInMs[path];
        }
      }

      // Timeout defined in APis
      if (callOptions && callOptions.defaultAjaxRequestTimeoutInMs) {
        return callOptions.defaultAjaxRequestTimeoutInMs;
      }

      return fallbackTimeoutInApplication;
    }
  });
  
  return AjaxChannel;
});

